import React from "react";
import styled from "styled-components";
import brandLogo from "../assets/betpilot-brand-07.png";

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 5%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`;

const Logo = styled.img`
  height: 40px;
`;

export const Header: React.FC = () => {
  return (
    <HeaderContainer>
      <Logo src={brandLogo} alt="Betpilot" />
    </HeaderContainer>
  );
};

